import axios from 'axios';
import React, { useState, useContext, createContext, useEffect } from 'react';

const AuthorizationContext = createContext();

export const useAuthorizationContext = () => {
  return useContext(AuthorizationContext);
};

const AuthorizationProvider = ({ children }) => {
  const [jwt, setJwt] = useState(localStorage.getItem('jwt'));
  const [headers, setHeaders] = useState({ Authorization: `Bearer ${jwt}` });

  const getAuthToken = async () => {
    try {
      const { data, status } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/auth`
      );
      localStorage.setItem('jwt', data.jwt);
      setJwt(data.jwt);
      setHeaders({ Authorization: `Bearer ${data.jwt}` });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (!jwt) {
      getAuthToken();
    }
  }, []);

  return (
    <AuthorizationContext.Provider value={{ jwt, headers, getAuthToken }}>
      {children}
    </AuthorizationContext.Provider>
  );
};

export default AuthorizationProvider;
